import { DELETE_USER, SET_USER, UserAction } from "../types";

// import the dependency
import { UserType } from "../../types";

const initialState: UserType | null = null;

export default (state: UserType | null = initialState, action: UserAction) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, ...action.payload };

    case DELETE_USER:
      return null;

    default:
      return state;
  }
};
